

import { defineComponent, PropType, ref } from 'vue';
import { PokemonInfo } from '@/models/PokemonInfo';

export default defineComponent({
  name: 'PokemonInfo',
  props: {
    pokemon: Object as PropType<PokemonInfo>
  },
  setup(props) {
    
    const types = ref([] as string[]);
    const stats = ref([] as { name: string, baseStat: number }[]);

    const getTypes = () => {
      types.value = props.pokemon?.types.map( type => type.type.name ) || [];
    }

    const getStats = () => {
      
      stats.value = props.pokemon?.stats.map( stats => {
        return {
          name: stats.stat.name.replace('-', ' '),
          baseStat: stats.base_stat
        }
      }) || [];
      
    }
    
    getTypes();

    getStats();

    return {
      types,
      stats
    }

  }
});
